import { FontItem } from '@goldcast/player-config/src/types/font-types';
import { FONTS_DEFAULT, PLATFORM_BRAND_KIT_PRESET_FONTS } from '@goldcast/player-config/src/constants/fonts';
import { getFontFullPath } from '@goldcast/player-config/src/utils/fontUtils';

export const fontsMap = () => {
  return FONTS_DEFAULT.reduce((acc, el) => {
    return {
      ...acc,
      [el.url]: el.name
    };
  }, {});
};

export function getFontByName(name?: string): FontItem | undefined {
  if (!name) {
    return;
  }
  return FONTS_DEFAULT.find(f => f.name === name);
}

export function getPlatformBrandKitPresetFontByOriginalName(originalName: string) {
  const row = PLATFORM_BRAND_KIT_PRESET_FONTS.find(p => p.originalName === originalName.trim());
  if (!row) {
    return undefined;
  }
  return {
    name: row.name,
    url: getFontFullPath(row.file)
  };
}
